var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandShapes3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.804 39.2588V132.145H39.5082L72.8996 98.9014C76.6423 95.1766 76.6423 89.1197 72.8996 85.3948L3.62932 16.4313C-2.39705 10.4305 1.85588 0.14502 10.3617 0.14502H75.5566C78.0798 0.14502 80.5002 1.14307 82.2861 2.92468L119.066 39.5331C122.787 43.2363 128.807 43.2363 132.528 39.5331L132.804 39.2588Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandShapes3);
export default __webpack_public_path__ + "static/media/BrandShapes3.bb12e353520ae2ecc3286df47b421d01.svg";
export { ForwardRef as ReactComponent };